<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003606.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 0,
          label: 'P0003606.dashboard.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-danger',
        },
        {
          ref: 1,
          label: 'P0003606.dashboard.regul' | translate,
          icon: 'fa-kit fa-picto-programme',
          color: 'color-orange',
        },
      ]"
      [value]="this.actionStack!.getValue('iphCActivationRegulation')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Controle,
          'iphCActivationRegulation',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row align-items-center">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003606.controle.amorcage' | translate
      }}</ion-label>
    </div>
  </div>

  <div class="my-3 d-inline-block">
    <app-mode-control-simple
      [data]="
        actionStack!.getValue('iphCCommandeAmorcageCloud') === 0
          ? {
              label: 'P0003606.controle.amorcage' | translate,
              icon: 'fa-kit fa-picto-playregular',
              color: 'color-medium',
            }
          : {
              label: 'P0003606.controle.stop' | translate,
              icon: 'fa-kit fa-picto-stop',
              color: 'color-red',
            }
      "
      (onTouchStart)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Controle,
          'iphCCommandeAmorcageCloud',
          1
        );
        this.actionStack!.commit()
      "
      (onTouchEnd)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Controle,
          'iphCCommandeAmorcageCloud',
          0
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-simple>
  </div>
</div>
